import { render, staticRenderFns } from "./FaceCaptureModal.vue?vue&type=template&id=d35e9704"
import script from "./FaceCaptureModal.vue?vue&type=script&lang=js"
export * from "./FaceCaptureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports